export const GOOGLE_PLACES_COUNTRY_US_FILTER = 'country:us';
export const GOOGLE_PLACES_STATE_TYPE = 'administrative_area_level_1';
export const GOOGLE_PLACES_CITY_TYPE = 'locality';

// `google` is in the global namespace, provided by @types/google.maps
export type Prediction = google.maps.places.AutocompletePrediction;
export type GeocoderResult = google.maps.GeocoderResult;
